var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.rows)?_c('b-pagination',{staticClass:"custom-pagination",attrs:{"align":"center","total-rows":_vm.rows,"per-page":_vm.page_size},model:{value:(_vm.current_page),callback:function ($$v) {_vm.current_page=$$v},expression:"current_page"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }